module.exports = __webpack_public_path__ + "img/About 7636.dd7902df.jpg";